module.exports = __webpack_public_path__ + "static/media/riskSystemExosphere.04d1d340.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/press/riskSystemExosphere.mp3
// module id = 585
// module chunks = 0